<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.4755 17.7934C17.449 17.5594 19.352 17.0954 21.1571 16.429C19.6604 14.7677 18.7494 12.5684 18.7494 10.1562V9.42624C18.7496 9.40917 18.7496 9.39209 18.7496 9.375C18.7496 5.92322 15.9514 3.125 12.4996 3.125C9.04785 3.125 6.24963 5.92322 6.24963 9.375L6.24943 10.1562C6.24943 12.5684 5.33846 14.7677 3.8418 16.429C5.64693 17.0954 7.55008 17.5594 9.52373 17.7935M15.4755 17.7934C14.4996 17.9092 13.5065 17.9688 12.4994 17.9688C11.4925 17.9688 10.4995 17.9092 9.52373 17.7935M15.4755 17.7934C15.5723 18.0949 15.6246 18.4164 15.6246 18.75C15.6246 20.4759 14.2255 21.875 12.4996 21.875C10.7737 21.875 9.37463 20.4759 9.37463 18.75C9.37463 18.4164 9.42692 18.095 9.52373 17.7935"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgNotifications',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
